<div class="form-check">
	<input
		*ngIf="!switch"
		class="form-check-input {{extraClass}}"
		[ngClass]="{ 'ng-invalid': error }"
		[id]="id" name="{{id}}"
		type="checkbox"
		[(ngModel)]="value"
		(ngModelChange)="valueEmit();"
		[disabled]="disabled"
	/>
	<p-inputSwitch
		*ngIf="switch"
		class="{{extraClass}}"
		[ngClass]="{ 'ng-invalid': error }"
		[id]="id" name="{{id}}"
		[(ngModel)]="value"
		(ngModelChange)="valueEmit();"
		[disabled]="disabled"
	/>
	<label class="form-check-label" for="{{id}}" *ngIf="label">{{ label }}</label>
</div>
